module.exports = __webpack_public_path__ + "static/media/Artikel_Kreativität_der_KI.1d32b5b1.pdf";